export type MatomoConfig = {
    url: string;
    siteId: number;
};

let initialized = false;

export const getMatomoConfig = (): MatomoConfig | null => {
    const url = process.env.REACT_APP_MATOMO_URL?.trim().replace(/\/$/, '');
    const siteIdRaw = process.env.REACT_APP_MATOMO_SITE_ID?.trim();

    if (!url || !siteIdRaw) {
        return null;
    }

    const siteId = Number(siteIdRaw);
    if (!Number.isInteger(siteId) || siteId <= 0) {
        return null;
    }

    return { url, siteId };
};

const ensureMatomoQueue = (): void => {
    window._paq = window._paq ?? [];
};

const loadMatomoScript = (url: string): void => {
    const scriptSrc = `${url}/matomo.js`;

    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
};

export const initMatomo = (): void => {
    if (typeof window === 'undefined' || initialized) {
        return;
    }

    const config = getMatomoConfig();
    if (config === null) {
        return;
    }

    ensureMatomoQueue();
    window._paq?.push(['setTrackerUrl', `${config.url}/matomo.php`]);
    window._paq?.push(['setSiteId', config.siteId]);
    window._paq?.push(['enableLinkTracking']);

    loadMatomoScript(config.url);
    initialized = true;
};

export const trackMatomoPageView = (customUrl?: string): void => {
    const config = getMatomoConfig();
    if (config === null || !window._paq) {
        return;
    }

    if (customUrl) {
        window._paq.push(['setCustomUrl', customUrl]);
    }

    window._paq.push(['trackPageView']);
};

export const trackMatomoEvent = (
    category: string,
    action: string,
    name?: string,
    value?: number
): void => {
    const config = getMatomoConfig();
    if (config === null || !window._paq) {
        return;
    }

    if (name !== undefined && value !== undefined) {
        window._paq.push(['trackEvent', category, action, name, value]);
        return;
    }

    if (name !== undefined) {
        window._paq.push(['trackEvent', category, action, name]);
        return;
    }

    window._paq.push(['trackEvent', category, action]);
};
